import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import artistDetails from './locales/en/artistDetails.json';
import artistDetailsFinance from './locales/en/artistDetailsFinance.json';
import artistDetailsGeneral from './locales/en/artistDetailsGeneral.json';
import artistDetailsShows from './locales/en/artistDetailsShows.json';
import artists from './locales/en/artists.json';
import common from './locales/en/common.json';
import companies from './locales/en/companies.json';
import companyDetails from './locales/en/companyDetails.json';
import companyDetailsArtists from './locales/en/companyDetailsArtists.json';
import companyDetailsEmployees from './locales/en/companyDetailsEmployees.json';
import companyDetailsFinance from './locales/en/companyDetailsFinance.json';
import companyDetailsGeneral from './locales/en/companyDetailsGeneral.json';
import companyDetailsHolds from './locales/en/companyDetailsHolds.json';
import companyDetailsShows from './locales/en/companyDetailsShows.json';
import companyDetailsVenues from './locales/en/companyDetailsVenues.json';
import dashboard from './locales/en/dashboard.json';
import error from './locales/en/error.json';
import finance from './locales/en/finance.json';
import financeDeposits from './locales/en/financeDeposits.json';
import financeOverview from './locales/en/financeOverview.json';
import legal from './locales/en/legal.json';
import notifications from './locales/en/notifications.json';
import personDetails from './locales/en/personDetails.json';
import personDetailsGeneral from './locales/en/personDetailsGeneral.json';
import personDetailsSettlements from './locales/en/personDetailsSettlements.json';
import personDetailsTourRep from './locales/en/personDetailsTourRep.json';
import persons from './locales/en/persons.json';
import ticketSales from './locales/en/ticketSales.json';
import venueDetails from './locales/en/venueDetails.json';
import venueDetailsGeneral from './locales/en/venueDetailsGeneral.json';
import venueDetailsHolds from './locales/en/venueDetailsHolds.json';
import venueDetailsOverview from './locales/en/venueDetailsOverview.json';
import venueDetailsRental from './locales/en/venueDetailsRental.json';
import venueDetailsShows from './locales/en/venueDetailsShows.json';
import venues from './locales/en/venues.json';

export const resources = {
  en: {
    artistDetails,
    artistDetailsFinance,
    artistDetailsGeneral,
    artistDetailsShows,
    artists,
    common,
    companies,
    companyDetails,
    companyDetailsArtists,
    companyDetailsEmployees,
    companyDetailsFinance,
    companyDetailsGeneral,
    companyDetailsHolds,
    companyDetailsShows,
    companyDetailsVenues,
    dashboard,
    error,
    finance,
    financeDeposits,
    financeOverview,
    legal,
    notifications,
    personDetails,
    personDetailsGeneral,
    personDetailsSettlements,
    personDetailsTourRep,
    persons,
    ticketSales,
    venueDetails,
    venueDetailsGeneral,
    venueDetailsHolds,
    venueDetailsOverview,
    venueDetailsRental,
    venueDetailsShows,
    venues,
  },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  defaultNS: 'common',
  ns: [
    'artistDetails',
    'artistDetailsFinance',
    'artistDetailsGeneral',
    'artistDetailsShows',
    'artists',
    'common',
    'companies',
    'companyDetails',
    'companyDetailsArtists',
    'companyDetailsEmployees',
    'companyDetailsFinance',
    'companyDetailsGeneral',
    'companyDetailsHolds',
    'companyDetailsShows',
    'companyDetailsVenues',
    'dashboard',
    'error',
    'finance',
    'financeDeposits',
    'financeOverview',
    'legal',
    'notifications',
    'personDetails',
    'personDetailsGeneral',
    'personDetailsSettlements',
    'personDetailsTourRep',
    'persons',
    'ticketSales',
    'venueDetails',
    'venueDetailsGeneral',
    'venueDetailsHolds',
    'venueDetailsOverview',
    'venueDetailsRental',
    'venueDetailsShows',
    'venues',
  ],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
